module.exports = __webpack_public_path__ + "static/media/service2.fedc733e.svg";